export default __webpack_public_path__ + "static/media/NeueMontreal-Bold.0836656d.otf";